import { globalAction } from 'common/actions';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';

const useHandleClickDialog = () => {
  const [, dispatch] = useStore() as unknown as UseStoreValues;

  // Per SonarCloud and the React docs, JSX props should not use arrow functions
  function handleClick() {
    dispatch(globalAction.showCompanyDialog(true));
  }

  return handleClick;
};

export default useHandleClickDialog;
